import React from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import styles from './TableContent.module.scss';
import { tooltipStyle, tooltip, priceFenToYuanCell } from '@/components/TableCell';
import moment from 'moment';

const TableContent = ({
    renderData = [],
    tableAction,
}) => {

    const operateCell = (id, record) => {
        return < div className={styles.action} >
            <div className={styles.item} onClick={() => tableAction('edit', { id: record.id, title: '编辑规则', url: '/?cmd=com.xqxc.api.pig.mis.biz.platform.RechargeRuleMisService.updateRule', tip: '编辑规则操作成功' })}>编辑</div>
            <div className={styles.item} onClick={() => tableAction('delete', record)}>删除</div>
            {record.state == 1 && <div className={styles.item} onClick={() => tableAction('termination', record)}>终止</div>}
            <div className={styles.item} onClick={() => tableAction('edit', { id: record.id, title: '复用规则', url: '/?cmd=com.xqxc.api.pig.mis.biz.platform.RechargeRuleMisService.addRule', tip: '复用规则操作成功', type: 'copy' })}>复用</div>
        </div >;
    };

    const columns = [
        {
            title: '规则名称',
            dataIndex: 'title',
            key: 'title',
            width: '16%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '充值金额',
            dataIndex: 'rechargeAmount',
            key: 'rechargeAmount',
            width: '16%',
            align: 'center',
            onCell: tooltipStyle,
            render: priceFenToYuanCell
        },
        {
            title: '赠送金额',
            dataIndex: 'giftAmount',
            key: 'giftAmount',
            width: '16%',
            align: 'center',
            onCell: tooltipStyle,
            render: priceFenToYuanCell
        },
        {
            title: '起止时间',
            dataIndex: 'startTime',
            key: 'startTime',
            width: '18%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => tooltip(`${moment(text).format('YYYY-MM-DD')} - ${item.days == -1 ? '永久' : moment(item.overTime).format('YYYY-MM-DD')}`)
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: '16%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '18%',
            onCell: tooltipStyle,
            render: operateCell
        }
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={renderData}
            pagination={false}
            scroll={{ y: true }}
        />
    </div>;
};

TableContent.propTypes = {
    renderData: PropTypes.array, // 表格数据源
    tableAction: PropTypes.func, // 对表格的操作
};

export default TableContent;